'use strict';

jQuery(function($){
	$('form[type="financing"]').each(function(){
		var $form = $(this);
		$form.find('.range-field').slider($form);
		$form.find('input[type="tel"]').inputmask('999-999-9999');
	});
});